import { useMemo } from 'react';

import { seasonService } from '../../../../services';
import { createApiSlice } from '../../utils/createApiSlice';

const updateSeasonFieldDeviceSlice = createApiSlice({
  reducerPath: ['devices', 'seasonFieldDevices', 'updateSeasonFieldDevice'],
  apiFunction: seasonService.updateFieldDeviceV2
});

const { actions, useApiSelectors } = updateSeasonFieldDeviceSlice;

export const updateSeasonFieldDeviceActions = actions;

export const useUpdateSeasonFieldDeviceSelectors = () => {
  const { inProgress, success, errorMessage, response, updatedAt } =
    useApiSelectors();

  return useMemo(
    () => ({ inProgress, success, errorMessage, response, updatedAt }),
    [errorMessage, inProgress, response, success, updatedAt]
  );
};

export default updateSeasonFieldDeviceSlice;
